export function isAppleBrowser() {
  return !!(window as any).ApplePaySession;
}
